import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "WHO-GMP Aligned",
  "ISO 9001 : 2015",
  "Schedule M Compliant",
  "DCGI Approved",
  "GLP Quality Systems",
  "Pharmacovigilance Active",
  "ICH Q7 Guidelines",
  "USP/IP Monograph Tested",
];

export default function MarqueeRibbon() {
  return (
    <section
      data-testid="marquee-ribbon"
      className="border-y border-[var(--mp-border)] bg-white py-6"
    >
      <Marquee speed={40} gradient={false} pauseOnHover>
        {items.map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-12 px-12 font-mono-display text-[11px] tracking-[0.28em] uppercase text-[var(--mp-text-2)]"
          >
            <span>{it}</span>
            <span className="text-[var(--mp-brand)]">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
